import { Form, Input, Image, UploadFile } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useWatch } from "antd/lib/form/Form";
import KnowledgeUploader from "./KnowledgeUploader";
import { useOSSFileUrl } from "./useOSSFileUrl";

export default function PictureInput({
    form,
    prefix = [],
    fullPrefix = [],
    labelPre = '',
    name,
    fileNamePath,
}: any) {
    const { init, getVisitUrl } = useOSSFileUrl();
    const [previewOpen, setPreviewOpen]: any = useState(false);
    const [previewImage, setPreviewImage]: any = useState('');
    const [fileList, setFileList]: any = useState<UploadFile[]>([]);
    const [OSSData, setOSSData] = useState<any>(null);
    const backName = name ? name : [...fullPrefix, "icon"];
    const watchPath = useWatch(backName);
    const type = 'picture';

    useEffect(() => {
        const initializeOSS = async () => {
            const data = await init(type);
            setOSSData(data);
        };
        initializeOSS();
    }, []);

    useEffect(() => {
        const initializeFile = async () => {
            const fieldValue = form.getFieldValue(backName);
            if (!fieldValue) return;
            const path = await getVisitUrl(fieldValue);
            const list = [{ url: path, uid: -(new Date()).getTime(), status: 'done' }];
            setFileList(list);
        };
        initializeFile();
    }, [watchPath]);

    const handlePreview = async (file: UploadFile) => {
        setPreviewImage(file.url);
        setPreviewOpen(true);
    };

    const handleFileChange = async (fileList: any) => {
        if (!fileList || !Array.isArray(fileList) || fileList.length === 0) {
            setFileList([]);
            form.setFieldValue(backName, undefined);
            return;
        }
        const file = fileList[fileList.length - 1];
        // 监听所有状态变化
        if (file?.status === 'uploading') {
            console.log('文件上传中...');
            setFileList(fileList);
        } else if (file?.status === 'done') {
            console.log('文件上传完成', file?.url);
            const url = await getVisitUrl(file?.url);
            setFileList([{ url: url }]);
            form.setFieldValue(backName, file?.url || '');
            // callbackFileName(file);
        } else if (file?.status === 'error') {
            console.log('文件上传失败');
            setFileList([]);
            form.setFieldValue(backName, undefined);
        }
    }

    // const callbackFileName = (file: any) => {
    //     if (!fileNamePath || !file) return;
    //     const fileName = form.getFieldValue(fileNamePath);
    //     if (fileName) return;
    //     const name = file.name.substring(0, file.name.lastIndexOf("."));
    //     form.setFieldValue(fileNamePath, name);
    // }

    return <>
        <Form.Item label={`${labelPre}图片`} rules={[{ required: true, message: '不能为空' }]}>
            <KnowledgeUploader
                type={type}
                maxCount={1}
                value={fileList}
                ossData={OSSData}
                listType="picture-card"
                accept='image/*'
                onPreview={handlePreview}
                onChange={handleFileChange}
            >
                {fileList.length === 0 &&
                    <div>
                        <PlusOutlined />
                        <div style={{ marginTop: 8 }}>拖到这里</div>
                    </div>}
            </KnowledgeUploader>
        </Form.Item>
        <Form.Item hidden label={`图片`} name={name || [...prefix, "icon"]} rules={[{ required: true, message: '不能为空' }]}>
            <Input />
        </Form.Item>
        {previewImage && <Image
            wrapperStyle={{ display: 'none' }}
            preview={{
                visible: previewOpen,
                onVisibleChange: (visible) => setPreviewOpen(visible),
                afterOpenChange: (visible) => !visible && setPreviewImage(''),
            }}
            src={previewImage}
        />}
    </>
}